<template>
  <div class="forget-container">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <div style="color: transparent">占位符</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-form
          ref="passForm"
          :model="form"
          class="pass-form"
          :rules="passRules"
          size="mini"
        >
          <el-form-item prop="username">
            <el-input
              v-model.trim="form.username"
              v-focus
              style="margin-top: 20px"
              type="text"
              placeholder="请输入注册姓名"
              auto-complete="off"
            >
              <zr-icon slot="prefix" icon="user-alt"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              v-model.trim="form.phone"
              type="text"
              placeholder="请输入注册手机号/身份证号"
              maxlength="18"
              show-word-limit
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mobile-alt"></zr-icon>
            </el-input>
          </el-form-item>
          <!--          <el-form-item prop="email">
            <el-input
              v-model.trim="form.email"
              type="text"
              placeholder="请输入注册邮箱"
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mail-bulk"></zr-icon>
            </el-input>
          </el-form-item>-->
          <el-form-item prop="password">
            <el-input
              v-model.trim="form.password"
              type="password"
              placeholder="设置密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model.trim="form.confirmPassword"
              type="password"
              placeholder="确认密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="12">
                <el-button
                  class="register-btn"
                  type="primary"
                  @click.native.prevent="handleResetPassword"
                >
                  <zr-icon icon="unlock-alt"></zr-icon> 修改密码
                </el-button>
              </el-col>
              <el-col :span="6">
                <router-link class="link-login" to="/login">
                  <div style="margin-top: 10px; margin-left: 30px">
                    <zr-icon icon="door-open"></zr-icon> 登录
                  </div>
                </router-link>
              </el-col>
              <el-col :span="6">
                <router-link class="link-login" to="/">
                  <div style="margin-top: 10px; margin-left: 30px">
                    <span class="fa fa-home"> 首页</span>
                  </div>
                </router-link>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  isPhone,
  isEmail,
  isIdCard,
  isPassword,
} from "zr-util/src/utils/comm/validate";
import { resetPassword } from "@api/recruit/user/acl";
import { messageDuration } from "@/config/settings";
import {encryptedData} from "@/utils/encrypt";

export default {
  username: "Register",
  directives: {
    focus: {
      inserted(el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    const validateusername = (rule, value, callback) => {
      if ("" == value) {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!isPhone(value) && !isIdCard(value)) {
        callback(new Error("请输入正确的手机号/身份证号"));
      } else {
        callback();
      }
    };
    // const validateEmail = (rule, value, callback) => {
    //   if (!isEmail(value)) {
    //     callback(new Error("请输入正确的邮箱地址"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      isGetphone: false,
      getPhoneIntval: null,
      phoneCode: "获取验证码",
      showRegister: false,
      nodeEnv: process.env.NODE_ENV,
      title: this.$baseTitle,
      form: {},
      passRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
          { max: 20, trigger: "blur", message: "最多不能超过20个字" },
          { validator: validateusername, trigger: "blur" },
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            message: "输入手机号码/身份证号",
          },
          { validator: validatePhone, trigger: "blur" },
        ],
        // email: [
        //   { required: true, trigger: "blur", message: "请输入邮箱地址" },
        //   { validator: validateEmail, trigger: "blur" },
        // ],
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          { validator: validatePassword, trigger: "blur" },
        ],
      },
      loading: false,
      passwordType: "password",
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.getPhoneIntval = null;
    clearInterval(this.getPhoneIntval);
  },
  methods: {
    getPhoneCode() {
      this.isGetphone = true;
      let n = 60;
      this.getPhoneIntval = setInterval(() => {
        if (n > 0) {
          n--;
          this.phoneCode = "重新获取(" + n + "s)";
        } else {
          this.getPhoneIntval = null;
          clearInterval(this.getPhoneIntval);
          this.phoneCode = "获取验证码";
          this.isGetphone = false;
        }
      }, 1000);
    },
    handleResetPassword() {
      this.$refs["passForm"].validate(async (valid) => {
        if (valid) {
          let encryPassword = await encryptedData(this.form.password)
          const param = {
            loginUserName: this.form.username,
            loginParameter: this.form.phone,
            // email: this.form.email,
            password: encryPassword,
          };
          const res = await resetPassword(param);
          if (res.success) {
            //do
            this.$message.success({
              showClose: true,
              message: "修改密码成功！请登录",
              duration: messageDuration,
            });
          } else {
            this.$message.error({ showClose: true, message: res.message });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.forget-container {
  height: 100vh;
  background: url("~@/assets/login_images/bg_earth_sky.jpg") center center fixed
    no-repeat;
  background-size: cover;

  .title {
    font-size: 54px;
    font-weight: 500;
    color: rgba(14, 18, 26, 1);
  }

  .title-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(14, 18, 26, 1);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .register-btn {
    display: inherit;
    width: 160px;
    height: 50px;
    margin-top: 5px;
    font-size: 18px;
    border: 0;

    &:hover {
      opacity: 0.9;
    }
  }

  .pass-form {
    position: relative;
    max-width: 100%;
    margin: calc((100vh - 499px) / 2) 10% 10%;
    overflow: hidden;

    .forget-password {
      width: 100%;
      margin-top: 40px;
      text-align: left;

      .forget-password {
        width: 129px;
        height: 19px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(92, 102, 240, 1);
      }
    }

    .per-code {
      width: 100px;
      height: 36px;
      font-size: 20px;
      line-height: 36px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      background: #bbc1ce;
    }

    .phone-code {
      width: 120px;
      height: 36px;
      font-size: 14px;
      color: #fff;
      border-radius: 3px;
    }
  }

  .tips {
    margin-bottom: 10px;
    font-size: $base-font-size-default;
    color: $base-color-white;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      margin: 0 auto 40px auto;
      font-size: 34px;
      font-weight: bold;
      color: $base-color-blue;
      text-align: center;
    }
  }

  .svg-container {
    position: absolute;
    top: 14px;
    left: 15px;
    z-index: $base-z-index;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  .show-pwd {
    position: absolute;
    top: 14px;
    right: 25px;
    font-size: 16px;
    color: $base-font-color;
    cursor: pointer;
    user-select: none;
  }

  ::v-deep {
    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__content {
        min-height: $base-input-height;
        line-height: $base-input-height;
      }

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: $base-font-size-small;
        line-height: 18px;
        color: $base-color-red;
      }
    }

    .el-input {
      box-sizing: border-box;

      .el-input__count {
        .el-input__count-inner {
          background: transparent;
        }
      }

      .el-input__prefix {
        left: 15px;
        line-height: 56px;

        .svg-inline--fa {
          width: 20px;
        }
      }

      input {
        height: 58px;
        padding-left: 45px;
        font-size: $base-font-size-default;
        line-height: 58px;
        color: $base-font-color;
        background: #f6f4fc;
        border: 0;
        caret-color: $base-font-color;
      }
    }
  }
}
.link-login {
  color: $base-color-white;
  font-size: 20px;
}
</style>
